import { sendRequest } from "./api";

interface INote {

}

export const getNotes = () => {
    return sendRequest('note', 'GET', undefined, '');
}

export const postNote = (note: INote) => {
    return sendRequest('note', 'POST', note, '');
}

export const getNote = (noteId: string) => {
    return sendRequest('note/', 'GET', undefined, noteId);
}

export const putNote = (note: INote, noteId: string) => {
    return sendRequest('note/', 'PUT', note, noteId);
}

export const deleteNote = (noteId: string) => {
    return sendRequest('note/', 'DELETE', undefined, noteId);
}

